
import React, { useState } from 'react';


import {
    InputCopy,
    FormGroup,
    Select,
    Tooltip,
    StatusDot,
    Checkbox,
    Subheader,
    Pill,
    Button,
    Breadcrumbs,
    Head,
    FormFooter,
    Card,
    Input,
    RadioGroup,
    Switch,
    Icon,
    ButtonAction,
    Tag,
    Notification,
    ContentBlock,
    StepTabs
} from 'xsolla-uikit';

import { PAskuName } from '../PAskuName';

import PAContentBlock from "../PAContentBlock";


export function PAsubsNew() {

  const [step, setStep] = useState(0)

  const steps = [
    {
      label: 'Currency',
      value: 0,
      onClick: ()=>setStep(0)
    },
    {
      label: 'Set packages',
      value: 1,
      // disabled: true
      onClick: ()=>setStep(1)
    }]

  return (
    <div>

{/* <FormGroup indentation="lg">
      <StepTabs
        current={step}
        steps = {[...steps]}
      />
</FormGroup> */}

<FormGroup indentation="lg">

</FormGroup>





      <FormFooter sticky={true}>
          <Button appearance="outline">
                    Discard
                  </Button>

                  <Button type="submit">
                    Save changes
                  </Button>

      </FormFooter>

    </div>
  )
}
